var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheel2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1229 1229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:169px;stroke:#1d1d1b;font-family:BasisGrotesquePro-Black, Basis Grotesque Pro;font-weight:800;}.cls-1,.cls-2{fill:none;stroke-miterlimit:10;stroke-width:1.8px;}.cls-2{stroke:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-530.61 1076.49) rotate(171.73)"
  }, "\u0410"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-652.52 1093.46) rotate(-174.34)"
  }, "\u0425"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(-0.94, -0.34, 0.34, -0.94, -761.83, 1083.53)"
  }, "\u0410"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-877.69 1041.43) rotate(-146.13)"
  }, "\u0425"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-969.41 981.32) rotate(-132.49)"
  }, "\u0410"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-1047.52 891.8) rotate(-122.75)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(-0.39, -0.92, 0.92, -0.39, -1073.31, 858.02)"
  }, "\u0426"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-1119.28 753.46) rotate(-99.4)"
  }, "\u0418"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-1138.06 636.64) rotate(-86.58)"
  }, "\u0422"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-1136.64 558.29) rotate(-75.86)"
  }, "\u0410"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-1113.46 461.23) rotate(-65.13)"
  }, "\u0422"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-1076.99 372.36) rotate(-50.55)"
  }, "\u042B"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.78, -0.63, 0.63, 0.78, -977.08, 258.83)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-945.38 230.21) rotate(-30.43)"
  }, "\u0422"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.95, -0.3, 0.3, 0.95, -863.3, 179.81)"
  }, "\u0418"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(1, -0.08, 0.08, 1, -750.33, 144.61)"
  }, "\u0422"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-672.54 134.84) rotate(5.87)"
  }, "\u0410"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.96, 0.29, -0.29, 0.96, -573.14, 143.81)"
  }, "\u0422"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-480.03 167.08) rotate(31.32)"
  }, "\u042B"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.73, 0.68, -0.68, 0.73, -353.4, 249.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.61, 0.79, -0.79, 0.61, -320.01, 276.12)"
  }, "\u0426"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-249.49 365.92) rotate(66.3)"
  }, "\u0418"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-202.47 474.5) rotate(79.1)"
  }, "\u0422"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-184.49 550.86) rotate(89.73)"
  }, "\u0410"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-182.78 650.6) rotate(100.42)"
  }, "\u0422"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-195.18 737.86) rotate(113.19)"
  }, "\u041E"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-246.97 856.85) rotate(126.93)"
  }, "\u0427"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-308.65 940.58) rotate(139.74)"
  }, "\u041A"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(-0.89, 0.45, -0.45, -0.89, -388.41, 1010.22)"
  }, "\u0418"), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.73,768l-103.84-11.7L144.19,736l82.49-64.16,6.59,23.42L213.14,710l9.14,32.47,24.85,2.06Zm-68.47-28.41L202,740.88,196.68,722l-13.59,9.86-3.09,2.3a64.76,64.76,0,0,1-6.87,4.67c.67,0,1.61,0,2.82.07l3.12.12c.87,0,1.66.11,2.35.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.54,645.14l25.9-16.58-26.92-16-.74-23.63L173,615.14l51.38-33.29.79,25.15-32.28,20.38,33.49,18,.81,25.7-52.7-30.57-44.16,29.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M223.8,581.14l-86.23-59L142,501.57l102.93-18-5.16,23.78-24.68,3.56-7.15,33,21,13.47Zm-47.15-57.2,14.17,9L195,513.77l-16.63,2.33-3.81.59a65.37,65.37,0,0,1-8.26.9q.89.48,2.46,1.38c1,.61,1.95,1.13,2.7,1.58s1.42.87,2,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.92,413.93l30.66-2.36-16.14-26.86L197,363.54l27.44,44.51,61-5.05-11.2,22.54-38.08,2.69,21,31.73-11.44,23-32-51.85-52.91,5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285,402.05l-48.72-92.44,13.52-16.09,99.44,32.12-15.66,18.63-23.49-8.37-21.71,25.82,12.28,21.7Zm-15-72.59L278.28,344l12.64-15-15.81-5.7-3.64-1.26a64.85,64.85,0,0,1-7.72-3.06q.56.84,1.53,2.37c.65,1,1.2,1.91,1.65,2.66s.85,1.43,1.16,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M381.24,300.62l-49.41-83.23L351.09,206l39.38,66.34,29.37-17.44-39.39-66.33,19.26-11.44,39.39,66.34,5.23-3.1L462.54,271,444,282l-8.18-13.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M514.15,137.28l28.08,92.62-20.91,6.34L503.07,176a30.87,30.87,0,0,1-.92,5.05c-.47,2-.75,3.11-.84,3.43l-17.57,63.11L462,254.2,434,161.58l20.91-6.34L473,215.05a31.12,31.12,0,0,1,.93-5.05c.46-2,.74-3.11.84-3.43l17.68-62.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M542.71,152.07l-1.39-19.58,79.44-5.61,1.39,19.58-28.55,2,5.43,77L576.69,227l-5.44-77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M610.61,222.08,661,130.54,681.88,133l27.88,100.71-24.17-2.83-5.94-24.22-33.5-3.92-11.37,22.19ZM663,169.61l-7.6,15,19.5,2.28-3.93-16.33-1-3.73a64.89,64.89,0,0,1-1.69-8.13q-.39.93-1.14,2.58c-.5,1.1-.94,2.05-1.31,2.84s-.73,1.49-1.08,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M716.05,157.47l5.88-18.73,76,23.83L792,181.3l-27.31-8.56-23.09,73.61-21.37-6.7L743.36,166Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M826,173.33l19,11.87-19.34,31L843,227q13,8.13,17,20.1T856.57,271q-7.47,12-20,13.6t-25.53-6.5L774.7,255.41Zm23.53,128.82,51.28-82.08,19,11.87L868.51,314ZM816,231.63l-12.46,19.94L820.28,262q12,7.47,18.12-2.37,6.3-10.1-5.66-17.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M958.44,296.46l15.49-12,48.91,62.85-15.5,12.05-17.57-22.58-60.89,47.38-13.75-17.68L976,319.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1072.92,446.63l-87.69,41L976,467.8l57-26.62a31.39,31.39,0,0,1-5.13-.2c-2-.18-3.19-.29-3.52-.34l-65-8.41-9.59-20.54,87.68-41,9.25,19.79L990.08,417a32.18,32.18,0,0,1,5.13.2c2,.18,3.18.29,3.51.34l64.6,8.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1062.32,477l19.18-4.17,16.9,77.83-19.18,4.16-6.08-28L997.75,543.2,993,521.31l75.39-16.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1002.72,554.2l97.84,36.71.58,21L1005.49,654l-.67-24.32,23.11-9.36-.94-33.72-23.59-8.06Zm59.46,44.27-15.92-5.36.55,19.62,15.59-6.24L1066,605a62.84,62.84,0,0,1,7.8-2.85l-2.71-.75c-1.17-.34-2.17-.63-3-.89s-1.59-.51-2.24-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1081.84,649.28l19.38,3.12L1088.56,731l-19.38-3.12,4.55-28.25-76.17-12.27,3.56-22.11,76.17,12.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1081.85,760.47,1072.79,781l-33.38-14.76-8.28,18.71q-6.21,14-17.48,19.7t-24.18,0q-12.88-5.72-16.28-17.87T976,760.51l17.34-39.2Zm-59.13-1.67-21.49-9.51-8,18.08q-5.72,12.9,4.91,17.6,10.88,4.8,16.58-8.09ZM957.66,802l88.51,39.16-9.07,20.48-88.5-39.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M919.18,860.85l68.56,68.31L971.93,945l-54.65-54.45-24.1,24.19,54.65,54.45L932,985.09l-54.65-54.46-4.3,4.31L847.8,909.77,863,894.49l11.36,11.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M830.85,1052l-50.07-82.82,18.69-11.3L832,1011.75a30.5,30.5,0,0,1-.35-5.12c0-2,0-3.2,0-3.53l1.45-65.5,19.4-11.73,50.07,82.83-18.7,11.3-32.33-53.48a30,30,0,0,1,.35,5.12c0,2,0,3.2,0,3.53l-1.66,65.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M799.54,1044.73l6.18,18.64-75.58,25.07L724,1069.81l27.16-9-24.3-73.23,21.26-7.05,24.3,73.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M716.37,993.68l-26,101.2-20.82,2.83-52.06-90.61,24.11-3.27,11.77,22,33.43-4.53L692.25,997Zm-37.66,63.85,3.63-16.4-19.45,2.64,7.87,14.84,1.85,3.38a63.21,63.21,0,0,1,3.67,7.45c.09-.66.25-1.59.46-2.78s.39-2.22.56-3.08.33-1.63.52-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M630.4,1082.51l-1,19.61L549.85,1098l1-19.61,28.58,1.48,4-77,22.37,1.16-4,77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M452,1060.62q-10-17.91-4.27-38.41t23.69-30.53q17.91-10,38.94-4.11t31.06,23.83q10,17.91,4.26,38.41T522,1080.34q-17.91,10-38.94,4.11T452,1060.62Zm70-39.81a29.4,29.4,0,0,0-39-11q-10.11,5.56-13.75,18.47t2.09,22.92a29.4,29.4,0,0,0,39,11q10.13-5.57,13.75-18.47T522,1020.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M375.12,1007.81l-12.66,22.39-18.29-10.34,47.61-84.26,18.3,10.34-19.73,34.91a25.35,25.35,0,0,1,10.5-.73,33.38,33.38,0,0,1,10.75,4.16q11.91,6.74,15.45,18.89T421.74,1031l-14,24.8-18.29-10.34,13.47-23.83q4.28-7.59,2.76-13.61a14.42,14.42,0,0,0-7.3-9.28,15,15,0,0,0-12.15-1.55Q380.09,999,375.12,1007.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.41,944.73l50.64-3.28,13.66-69.06,18.82,17.11L328.4,940.1l12.39-.89,23.72-26.08,16.57,15.07L316,999.8l-16.57-15.07,22.33-24.55c-.78,0-1.79.15-3,.34s-2.1.3-2.63.32l-2.63.22-37.37,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M190.49,855.13l79.83-54.71,12.35,18L230.78,854a31.26,31.26,0,0,1,5.09-.64c2-.15,3.2-.23,3.53-.24l65.47-2.29,12.82,18.7-79.84,54.71-12.34-18,51.54-35.33a31.31,31.31,0,0,1-5.09.64c-2,.15-3.19.23-3.52.23l-65.13,2.06Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheel2);
export default __webpack_public_path__ + "static/media/wheel2.7d757849b2fd0894341108df1fea94d6.svg";
export { ForwardRef as ReactComponent };